import styled from 'styled-components';
import { Base } from '../styles';

export const WrappedBase = styled(Base)`
	// we need to change a couple of Base's properties to make the dropdown show
	overflow: visible;
	position: relative;
`;

export const FontList = styled.div`
	display: block;
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	background: ${({ theme }) => theme.gray[100]};
	z-index: 1000;
	max-height: 400px;
	overflow-y: auto;
	margin-top: 4px;
`;

export const FontItem = styled.div<{ $active?: boolean }>`
	padding: 8px 12px;
	font-size: 12px;
	color: ${({ theme }) => theme.gray[1000]};
	text-align: left;
	background: ${({ theme, $active }) => ($active ? theme.gray[200] : 'transparent')};

	&:hover {
		background: ${({ theme }) => theme.gray[200]};
	}
`;

export const LoadingText = styled.div`
	padding: 12px;
	text-align: center;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 12px;
	font-family: 'Inter', sans-serif;
`;

type SwatchProps = {
	size?: string;
	color: string;
};
export const Swatch = styled.div.attrs((props) => ({
	style: {
		backgroundColor: props.color,
	},
}))<SwatchProps>`
	box-sizing: border-box;
	width: 14px;
	height: 14px;
	border-radius: 2px;
	border: 0px solid #fff;
	margin-left: -2px;
`;
